import { formatTime } from '../../utils/dateUtils'

export default function MessageBubble({ message }) {
  const isUser = message.role === 'user'
  const time = formatTime(message.created_at)

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}>
      <div className={`max-w-[80%] ${isUser ? 'order-1' : ''}`}>
        <div
          className={`px-3.5 py-2.5 rounded-2xl text-sm leading-relaxed ${
            isUser
              ? 'bg-brand-600 text-white rounded-br-sm'
              : 'bg-slate-100 text-slate-800 rounded-bl-sm'
          }`}
        >
          {message.content}
        </div>
        <div className={`flex items-center space-x-1.5 mt-1 ${isUser ? 'justify-end' : 'justify-start'}`}>
          <span className="text-[10px] text-slate-400">{time}</span>
          {!isUser && message.agent_used && (
            <span className="text-[10px] text-slate-300 bg-slate-50 px-1.5 py-0.5 rounded">
              {message.agent_used}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
